import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';

import FontAwesome from 'utils/FA';
import Reminder from 'components/Reminders/Reminder';

import './ReminderList.scss';

const ReminderList = ({
  onDestroy,
  onSave,
  reminders,
  showContact,
  users
}) => {
  if (!reminders.ready) {
    return (
      <div className='reminder-list reminder-list-loading'>
        <FontAwesome icon={faCircleNotch} className='reminder-list-loading fa-spin' />
      </div>
    );
  }

  if (reminders.length === 0) {
    return (
      <div className='reminder-list'>
        <div className='card bg-light empty'>
          There are currently no reminders.
        </div>
      </div>
    );
  }

  const betweenDates = (attribute, start, end) => (appointment) => (
    (typeof start === 'number' ? moment(appointment[attribute]) >= moment().add(start, 'day').startOf('day') : true)
    && (typeof end === 'number' ? moment(appointment[attribute]) < moment().add(end, 'day').startOf('day') : true)
  );

  const overdue = reminders.filter(betweenDates('due_date', null, 0));
  const today = reminders.filter(betweenDates('due_date', 0, 1));
  const upcoming = reminders.filter(betweenDates('due_date', 1, 7));
  const later = reminders.filter(betweenDates('due_date', 7));

  const sections = [
    { header: 'Overdue', items: overdue, canonical: 'overdue' },
    { header: 'Today', items: today, canonical: 'today' },
    { header: 'Next 7 Days', items: upcoming, canonical: 'upcoming' },
    { header: 'Later', items: later, canonical: 'later' }
  ];

  return (
    <div className='reminder-list'>
      {
        sections.map((section) => (
          section.items.length > 0 && (
            <div className={`reminder-list-${section.canonical}`} key={section.header}>
              <div className='reminder-list-section-header'>
                {section.header}
              </div>
              <TransitionGroup>
                {
                  section.items.map((reminder) => (
                    <CSSTransition timeout={600} key={reminder.id} classNames='reminder-list'>
                      <div>
                        <Reminder
                          {...reminder}
                          onSave={onSave}
                          onDestroy={onDestroy}
                          showContact={showContact}
                          users={users}
                        />
                      </div>
                    </CSSTransition>
                  ))
                }
              </TransitionGroup>
            </div>
          )
        ))
      }
    </div>
  );
};

ReminderList.defaultProps = {
  onDestroy: () => false,
  onSave: () => false,
  reminders: [],
  showContact: false,
  users: []
};

ReminderList.propTypes = {
  onDestroy: PropTypes.func,
  onSave: PropTypes.func,
  reminders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ),
  showContact: PropTypes.bool,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  )
};

export default ReminderList;
